import CustomerListReducer from './customer/CustomerListReducer';
import { combineReducers } from 'redux'

export default combineReducers({
    customerList: CustomerListReducer,
});



// WEBPACK FOOTER //
// ./src/view/reducer/CustomerReducer.js